<template lang="pug">
  LayoutDefault
    .page: .container-fluid
      .section: .card: .card--body
        .heading--section FPX E-Payment
        .pad_t--30
          FPXDeposit
</template>



<script>
  import FPXDeposit from '@/components/FPXDeposit';

  export default {
    name: 'paymentDeposit',

    components: {
      FPXDeposit,
    },
  }
</script>